import React from 'react';
import { BrowserRouter as Router, Route, Routes, Link, Navigate, useLocation } from 'react-router-dom';
import EntraCleanChatBot from './components/EntraCleanChatBot';
import MetropolisChatBot from './components/MetropolisChatBot';
import ExpoXTCiscoWebex from './components/ExpoXTCiscoWebex';
import ExpoXTNEC from './components/ExpoXTNEC';
import PromptEngineer from './components/PromptEngineer';
import AInsightsChatBot from './components/AInsightsChatBot';
import ChatbaseChatBot from './components/ChatbaseChatBot'; // Import the new Chatbase component

// Separate the layout including navigation
const Layout: React.FC = () => {
  const location = useLocation(); // useLocation is inside Router context now

  // Define paths where the navigation should not appear
  const hideNavPaths = ['/chatbase'];

  return (
    <div>
      {/* Conditionally render the navigation menu */}
      {!hideNavPaths.includes(location.pathname) && (
        <nav>
          <ul>
            <li>
              <Link to="/entraclean">EntraClean ChatBot</Link>
            </li>
            <li>
              <Link to="/metropolis">Metropolis ChatBot</Link>
            </li>
            <li>
              <Link to="/expoxt-cisco-webex">ExpoXT Cisco Webex ChatBot</Link>
            </li>
            <li>
              <Link to="/expoxt-nec">ExpoXT NEC ChatBot</Link>
            </li>
            <li>
              <Link to="/promptengineer">Prompt Engineer ChatBot</Link>
            </li>
            <li>
              <Link to="/ainsights">AInsights ChatBot</Link>
            </li>
            <li>
              <Link to="/chatbase">Chatbase ChatBot</Link> {/* New navigation link for Chatbase */}
            </li>
          </ul>
        </nav>
      )}

      <Routes>
        <Route path="/" element={<Navigate to="/entraclean" replace />} />
        <Route path="/entraclean" element={<EntraCleanChatBot />} />
        <Route path="/metropolis" element={<MetropolisChatBot />} />
        <Route path="/expoxt-cisco-webex" element={<ExpoXTCiscoWebex />} />
        <Route path="/expoxt-nec" element={<ExpoXTNEC />} />
        <Route path="/promptengineer" element={<PromptEngineer />} />
        <Route path="/ainsights" element={<AInsightsChatBot />} />
        <Route path="/chatbase" element={<ChatbaseChatBot />} /> {/* New route for Chatbase */}
      </Routes>
    </div>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      {/* The Layout component which includes the navigation and routes */}
      <Layout />
    </Router>
  );
};

export default App;